import { ReactComponent as CallMade } from "../source/img/icons/call_made.svg"
import { ReactComponent as CallReceived } from "../source/img/icons/call_received.svg"
import { ReactComponent as DashboardIcon } from "../source/img/icons/dashboard.svg"
import { ReactComponent as DesignServices } from "../source/img/icons/design_services.svg"
import { ReactComponent as EditAttributes } from "../source/img/icons/edit_attributes.svg"
import { ReactComponent as Inventory2 } from "../source/img/icons/inventory_2.svg"
import { ReactComponent as LocalShipping } from "../source/img/icons/local_shipping.svg"
import { ReactComponent as RequestQuote } from "../source/img/icons/request_quote.svg"
import { ReactComponent as Storage } from "../source/img/icons/storage.svg"
import { ReactComponent as Cog } from "../source/img/icons/settings_black_24dp.svg"
import { ReactComponent as Container } from "../source/img/icons/order_container.svg"
import { ReactComponent as Person } from "../source/img/icons/person.svg"
import { ReactComponent as ShoppingCart } from "../source/img/icons/shopping_cart.svg"
import { ReactComponent as Maintenance } from "../source/img/icons/maintenance.svg"
import { ReactComponent as CalendarMonth } from "../source/img/icons/calendar_month.svg"
import { ReactComponent as LeaderBoard } from "../source/img/icons/leader_board.svg"
import { ReactComponent as Order } from "../source/img/icons/order.svg"
import { ReactComponent as Payments } from "../source/img/icons/payments.svg"
import {
  faCloud,
  faCloudRain,
  faSnowflake,
  faSun,
} from "@fortawesome/free-solid-svg-icons"

// アイコン表示用
export const menuIcons = {
  DashboardIcon: <DashboardIcon className="menu-icon" />,
  CallReceived: <CallReceived className="menu-icon" />,
  CallMade: <CallMade className="menu-icon" />,
  Inventory2: <Inventory2 className="menu-icon" />,
  RequestQuote: <RequestQuote className="menu-icon" />,
  EditAttributes: <EditAttributes className="menu-icon" />,
  LocalShipping: <LocalShipping className="menu-icon" />,
  Storage: <Storage className="menu-icon" />,
  DesignServices: <DesignServices className="menu-icon" />,
  Cog: <Cog className="menu-icon" />,
  Container: <Container className="menu-icon" />,
  Person: <Person className="menu-icon" />,
  ShoppingCart: <ShoppingCart className="menu-icon" />,
  Maintenance: <Maintenance className="menu-icon" />,
  CalendarMonth: <CalendarMonth className="menu-icon" />,
  LeaderBoard: <LeaderBoard className="menu-icon" />,
  Order: <Order className="menu-icon" />,
  Payments: <Payments className="menu-icon" />,
} as const

/**
 * 天候区分用アイコン一覧
 */
export const tenkoIcon = {
  sun: faSun,
  cloud: faCloud,
  "cloud-rain": faCloudRain,
  snowflake: faSnowflake,
} as const

export type TTenkoIcon名称 = keyof typeof tenkoIcon
export type TTenkoIcon = (typeof tenkoIcon)[TTenkoIcon名称]
